// extracted by mini-css-extract-plugin
export default {"container":"customer-info_container__k1j18","section":"customer-info_section__2kOY-","field":"customer-info_field__fvjQb"};